<template>
    <div class="pl20 pr20">
        <div class="add_brand mt20">
            <el-form :model="brandInfo" :rules="rules" ref="brandInfo" label-width="200px" class="demo-ruleForm">
                <p align="center" class="f999">如果【申请大V店已有品牌】功能没有找到您要经营的品牌，请添加品牌信息，审核通过后会将品牌信息录入大V店品牌库：</p>
                <!-- 品牌中文名称 -->
                <el-form-item class="mt10" label="品牌中文名称：" prop="brandName">
                    <el-input class="w500" v-model="brandInfo.brandName" placeholder="请输入品牌中文名称"></el-input>
                </el-form-item>
                <!-- 品牌英文名称 -->
                <el-form-item label="品牌英文名称：" prop="brandEnname">
                    <el-input class="w500" v-model="brandInfo.brandEnname" placeholder="请输入品牌英文名称"></el-input>
                </el-form-item>
                <p class="ml200 f999">如果品牌没有中文名称或者英文名称，请在“中文名称”和“英文名称”输入相同的内容。</p>
                <!-- 品牌介绍 -->
                <el-form-item label="品牌介绍：" prop="brandDesc" class="dib mt20">
                    <el-input class="w500" :autosize="{ minRows: 6, maxRows: 10}" type="textarea" v-model="brandInfo.brandDesc" placeholder="入驻品牌的介绍，品牌商品的卖点" :maxlength="200"></el-input>
                </el-form-item>
                <span class="word_num">您可以输入 <span class="main_word">{{ amount }}</span> 个字</span>
                <!-- 重点商品 -->
                <el-form-item label="重点商品：" prop="brandGoodsDesc">
                    <el-input class="w500" :autosize="{ minRows: 6, maxRows: 10}" type="textarea" v-model="brandInfo.brandGoodsDesc" placeholder="重点商品介绍及线上链接，建议三款商品左右"></el-input>
                </el-form-item>
            </el-form>
        </div>

        <div class="mt20">
            <el-form :model="brandInfo" label-width="200px" class="demo-ruleForm">
                <!--品牌合作类型-->
                <el-form-item label="品牌合作类型：">
                    <span class="main_word rule_star123 vtb">*</span>
                    <el-checkbox-group class="dib vtb ml_10" v-model="brandType">
                        <el-checkbox :disabled="initBook" label="1">图书类</el-checkbox>
                        <el-checkbox :disabled="initNotBook" label="2">非图书类</el-checkbox><br/>
                    </el-checkbox-group>
                </el-form-item>
                <!--品牌合作品类-->
                <el-form-item label="品牌合作品类：">
                    <span class="main_word rule_star123 vtb">*</span>
                    <!--一级类目-->
                    <el-select class="ml_10 vtb" v-model="cata.first" placeholder="请选择一级类目"
                               @change="getTowList">
                        <el-option v-for="val in oneList" :label="val.name" :value="val.id" :key="val.id">
                        </el-option>
                    </el-select>
                    <!--二级类目-->
                    <el-select class="vtb" v-model="cata.second" placeholder="请选择二级类目"
                               @change="getThreeList">
                        <el-option v-for="val in twoList" :label="val.name" :value="val.id"
                                   :key="val.id">

                        </el-option>
                    </el-select>
                    <!--三级类目-->
                    <el-select class="vtb" @change="selectInfo" v-model="cata.categoryId"
                               placeholder="请选择三级类目">
                        <el-option v-for="val in threeList" :label="val.name" :value="val.id"
                                   :key="val.id"></el-option>
                    </el-select>
                    <el-button class="vtb" type="primary" @click="addDomain">添加合作类目</el-button>
                </el-form-item>

                <!--表格-->
                <el-table :data="brandInfo.categories" border style="width: 100%;margin: 0 auto;margin-bottom:22px">
                    <el-table-column label="主营品类"
                                     width="200"
                                     align="center">
                        <template scope="scope">
                            <span>{{ scope.row.category.grandName }}--</span>
                            <span>{{ scope.row.category.parentName }}--</span>
                            <span>{{ scope.row.category.childrenName }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="是否提供发票"
                                     width="150"
                                     align="center">
                        <template scope="scope">
                            <el-radio-group v-model="scope.row.provideInvoice" @change="selProvideInvoice(scope.row,scope.store)" :disabled="provideInvoice != null">
                                <el-radio :label="0"><span class="f14 f666">否{{brandInfo.provideInvoice != null}}</span></el-radio>
                                <el-radio :label="1"><span class="f14 f666">是</span></el-radio>
                            </el-radio-group>
                        </template>
                    </el-table-column>

                    <el-table-column label="发票类型" align="center" width="180">
                        <template scope="scope">
                            <el-select :disabled="scope.row.provideInvoice==0" @change="selInvoiceType(scope.row)"
                                       v-model="scope.row.invoiceType"
                                       placeholder="请选择发票类型">
                                <el-option v-if="registeredCountry == 1"  label="增值税普通发票" :value="1"></el-option>
                                <el-option v-if="registeredCountry == 1 && taxpayerType==1" label="增值税专用发票" :value="2"></el-option>
                                <el-option v-if="registeredCountry == 1 && taxpayerType==2" label="增值税专用发票（需去税务局代开）" :value="2"></el-option>
                                <el-option v-if="registeredCountry != 1" label="形式发票" :value="3"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>

                    <el-table-column label="税率" align="center" min-width="200">
                        <template scope="scope"
                                  v-if="scope.row.ratesStr != null && scope.row.ratesStr != undefined ">
                            <el-radio-group v-model="scope.row.ratesStr" v-if="taxpayerType==1 && scope.row.invoiceType==1">
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="0">0%</el-radio>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="6">6%</el-radio>
                                <br>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="9">9%</el-radio>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="10">10%</el-radio>
                                <br>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="13">13%</el-radio>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="16">16%</el-radio>
                            </el-radio-group>
                            <el-radio-group v-model="scope.row.ratesStr" v-if="taxpayerType==1 && scope.row.invoiceType==2">
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="6">6%</el-radio>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="9">9%</el-radio>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="10">10%</el-radio>
                                <br>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="13">13%</el-radio>
                                <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="16">16%</el-radio>
                            </el-radio-group>
                            <el-radio-group v-model="scope.row.ratesStr" v-if="taxpayerType==2">
                                <el-radio :disabled="scope.row.provideInvoice==0" label="0">0%</el-radio>
                                <el-radio :disabled="scope.row.provideInvoice==0" label="3">3%</el-radio>
                            </el-radio-group>
                        </template>
                    </el-table-column>

                    <el-table-column width="200" label="品类经营特许资质电子版" align="center">
                        <template scope="scope" >
                            <el-upload class="hide_up" v-show="scope.row.franchiseQualification"
                                       style="max-height: 149px;overflow: hidden;"
                                       action="/suppliers/uploadImageData?biz=0"
                                       name="pic"
                                       :data="{data:scope.$index}"
                                       list-type="picture-card"
                                       :file-list="scope.row.franchiseQualificationFile"
                                       :on-preview="handlePictureCardPreview"
                                       :on-remove="handleRemove"
                                       :on-success="handleUpload"
                                       :before-upload="beforeUpload"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <span v-if="!scope.row.franchiseQualification == 1">不需要</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="76" align="center">
                        <template scope="scope">
                            <el-button
                                    size="small"
                                    type="danger"
                                    @click="deleteDomain(scope.$index, brandInfo.categories)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--商品是否进口 -->
                <el-form-item v-show="!isBook" label="商品是否进口：">
                    <span class="main_word rule_star123">*</span>
                    <el-radio-group class="f666 f12 ml_10" v-model="brandInfo.goodsType" @change="goodsTypeChange">
                        <el-radio :disabled="registeredCountry !=1" :label="1"><span class="f14 f666">非进口</span></el-radio>
                        <el-radio :label="2"><span class="f14 f666">进口</span></el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 品牌经营方式 -->
                <el-form-item v-show="!isBook" label="品牌经营方式：">
                    <span class="main_word rule_star123 vtb">*</span>
                    <el-select class="ml_10 vtb" v-model="brandInfo.businessType" placeholder="请选择品牌经营方式">
                    <el-option :value="1" label="自有品牌"></el-option>
                    <el-option :value="2" label="代理商"></el-option>
                    <el-option v-show="(registeredCountry == 1 && brandInfo.goodsType == 2) || (registeredCountry != 1)" :value="3" label="其他"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 商标注册证电子版 -->
                <!-- 非图书 商品进口+品牌经营方式（非进口+自由品牌/代理商）/ -->
                <el-form-item v-if="!isBook && ((registeredCountry == 1 && (brandInfo.goodsType == 1) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2)) )" label="商标注册证电子版：" class="dib">
                    <span class="main_word rule_star148">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.trademarkRegistrationCertificateFiles"
                               list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveTrademark"
                               :on-success="handleSuccess1" :before-upload="beforeUpload">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                </el-form-item>
                <!-- 完整授权链证书电子版 -->
                <el-form-item v-if="!isBook && ((registeredCountry == 1 && (brandInfo.goodsType == 1) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2)) )" label="上传完整授权链证书电子版：" class="dib mt20">
                    <span class="main_word rule_star204">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.authCertificateFiles"
                               list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveAuthCert"
                               :on-success="handleSuccess2" :before-upload="beforeUpload">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                </el-form-item>
                <!-- 订货单电子版 -->
                <el-form-item v-if="!isBook && ((registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3)) )" label="订货单电子版：" class="dib mt20">
                    <span class="main_word rule_star123">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.purchaseOrderFiles"
                               list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemovePurchaseOrder"
                               :on-success="handleSuccess3" :before-upload="beforeUpload">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                </el-form-item>
                <!-- 报关单扫描件 -->
                <el-form-item v-if="!isBook && ((registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3)))" label="报关单扫描件：" class="dib mt20">
                    <span v-if="!((registeredCountry != 1 && brandInfo.businessType == 3) || (registeredCountry == 1 && brandInfo.goodsType == 2 && brandInfo.businessType == 3))" class="main_word rule_star123">*</span>
                    <span class="f666 f12 ml_10">同一批次商品的报关单和出入境检验检疫的证件，复印件需加盖公司红章扫描上传</span>
                    <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.customsDeclarationFormFiles"
                               list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveCustomsForm"
                               :on-success="handleSuccess4" :before-upload="beforeUpload">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                </el-form-item>
                <!-- 入境货物检验检疫证明 -->
                <el-form-item v-if="!isBook && ((registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						|| (registeredCountry == 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3))
						|| (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 1 || brandInfo.businessType == 2))
						 || (registeredCountry != 1 && (brandInfo.goodsType == 2) && (brandInfo.businessType == 3)))" label="入境货物检验检疫证明：" class="dib mt20">
                    <span v-if="!((registeredCountry != 1 && brandInfo.businessType == 3) || (registeredCountry == 1 && brandInfo.goodsType == 2 && brandInfo.businessType == 3))" class="main_word rule_star176">*</span>
                    <span class="f666 f12 ml_10">同一批次商品的报关单和出入境检验检疫的证件，复印件需加盖公司红章扫描上传</span>
                    <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.inspectionQuarantineFiles"
                               list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveInspectionQuarantine"
                               :on-success="handleSuccess6" :before-upload="beforeUpload">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                </el-form-item>
                <!-- 质检单电子版 -->
                <el-form-item v-if="!isBook && (registeredCountry == 1 && ((brandInfo.goodsType == 1) && (brandInfo.businessType == 1 || brandInfo.businessType == 2)))" label="质检单电子版：" class="dib mt20">
                    <span class="main_word rule_star123">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="brandInfo.qualityInspectionFiles"
                               list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveQualityInspection"
                               :on-success="handleSuccess5" :before-upload="beforeUpload">
                        <i class="el-icon-plus"></i>
                    </el-upload>

                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                </el-form-item>
                <!-- 质检日期 -->
                <el-form-item v-if="!isBook && (registeredCountry==1 && (brandInfo.goodsType == 1 && (brandInfo.businessType == 1 || brandInfo.businessType == 2)))" label="质检日期：">
                    <span class="main_word rule_star92 vtb">*</span>
                    <el-date-picker class="ml_10 vtb" v-model="dateTime" type="date"
                                    placeholder="请选择质检日期" @change="getseconds">
                    </el-date-picker>
                </el-form-item>

            </el-form>
            <div align="center" class="mb20">
                <el-button class="mr10" type="primary" @click="cancel()">取消</el-button>
                <el-button type="primary" @click="submit('brandInfo')">保存</el-button>
            </div>
        </div>

        <!-- 搜索结果弹框 -->
        <el-dialog title="" :visible.sync="search_result" size="small">
            <div class="wp100 tc">搜索结果如下，若没有您要的品牌，请【添加新品牌】</div>

            <div class="mt20 result_radio">
                <el-radio-group class="radio_group" v-model="radio" @change="change_select">
                    <el-radio v-for="val in list" class="list_radio" :label="val.brandId" :key="val.brandId">{{ val.brandName }}</el-radio>
                </el-radio-group>
            </div>

            <span slot="footer" class="dialog-footer" align="center">
			    <el-button @click="search_result = false">取 消</el-button>
			    <el-button :disabled="noSelect" type="primary" @click="sure_select">确 定</el-button>
			  </span>
        </el-dialog>
        <!--搜索无内容弹框-->
        <el-dialog title="" :visible.sync="noDialog" size="tiny">
            <span>没有搜索到相关品牌，请[添加新品牌]</span>
            <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="noDialog = false">确 定</el-button>
		  </span>
        </el-dialog>
        <!--预览图片-->
        <el-dialog :visible.sync="dialogVisible" size="small">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>


<script type="text/javascript">
    export default {
        data () {
            return {
                registeredCountry: 0,   // 注册地
                taxpayerType: 0,        // 纳税人类型
                deptId:0,               // 部门id,
                categoryDeptId:null,       // 主要为了根据部门获取品类信息,（暂时废弃）

                initBook: false,        // 初始化图书可选
                initNotBook: false,     // 初始化非图书可选

                brandType: [],          // 品牌合作类型
                brand_key: '',          // 搜索关键字
                list: [],               // 搜索结果列表
                search_result: false,	// 搜索有结果弹框
                noDialog: false,        // 搜索无结果页面
                radio: null,		    // 选中的内容
                noSelect: true,         // 未选择品牌 状态
                alSelect: false,	    // 已选择 品牌
                brandId: 0, 	        // 品牌id
                brandName: '',	        // 中文名称
                brandEnname: '',	    // 外文名称
                provideInvoice: null,
                isBook: true,          // 是否为图书类型

                // 图片预览
                dialogImageUrl: '',
                dialogVisible: false,

                // 合作品类 1 2 3级id
                cata: {
                    first: null,
                    second: null,
                    categoryId: null
                },
                oneList: [],            // 一级类目列表
                twoList: [],            // 二级类目列表
                threeList: [],          // 三级类目列表

                // 品类tpm
                tpmList: {},

                dateTime: "",           // 组件 质检日期

                // 提交数据
                brandInfo: {
                    brandName: '',      // 中文名称
                    brandEnname: '',    // 英文名称
                    brandDesc: '',      // 品牌介绍
                    brandGoodsDesc: '', // 重点商品

                    categoryIsBook: 0,      // 品牌类型 图书是否选中
                    categoryNotBook: 0,      // 品牌类型 非图书是否选中

                    goodsType: 2,       // 商品是否进口
                    businessType: "",       // 品牌经营方式
                    // 电子版资质
                    trademarkRegistrationCertificateFiles: [],
                    authCertificateFiles: [],
                    purchaseOrderFiles: [],
                    customsDeclarationFormFiles: [],		// 报关单扫描件
                    qualityInspectionFiles: [],		        // 质检单电子版
                    inspectionQuarantineFiles: [],		    // 入境货物检验检疫证明

                    qualityInspectionTime: 0,               // 质检日期

                    // 品类表格列表
                    categories: [

                    ],
                },
                // 验证
                rules: {
                    brandName: [
                        { required: true, message: '请输入品牌中文名称', trigger: 'blur' }
                    ],
                    brandEnname: [
                        { required: true, message: '请输入品牌英文名称', trigger: 'blur' }
                    ],
                    brandDesc: [
                        { required: true, message: '请输入品牌介绍', trigger: 'blur' },
                        { max: 200, message: '最多输入200个字', trigger: 'blur' }
                    ],
                    brandGoodsDesc: [
                        { required: true, message: '请输入请输入重点商品链接', trigger: 'blur' }
                    ],
                }
            }
        },
        mounted () {
            this.$nextTick(function() {
                var _this = this;
                var brandApplyId = this.$route.query.brandApplyId;
                var type = this.$route.query.isType;
                this.brandApplyId = brandApplyId;
                this.brandAgreementId = this.$route.query.brandAgreementId;
                // this.getCategory();
                if (brandApplyId != 0 && type == 2) {
                    this.fetch(brandApplyId)
                } else {
                    $.get({
                        url: '/suppliers/agreementApply/brandApplyAttachCondition/find',
                        data: {
                            agreementApplyId: _this.brandAgreementId
                        },
                        success: function (result) {
                            if (!result.code && result.data) {
                                _this.provideInvoice = result.data.provideInvoice;
                                _this.registeredCountry = result.data.registeredCountry;
                                _this.taxpayerType = result.data.taxpayerType;
                                _this.deptId = result.data.deptId;
                                if (result.data.categoryIsBook==1 && result.data.categoryNotBook==1) {
                                    _this.brandType = ["1","2"];
                                    _this.initBook = false;
                                    _this.initNotBook = false;
                                    _this.getCategory(3);
                                } else if (result.data.categoryIsBook==1 && result.data.categoryNotBook==0) {
                                    _this.brandType = ["1"]
                                    _this.initBook = false;
                                    _this.initNotBook = true;
                                    _this.getCategory(1);
                                } else if (result.data.categoryIsBook==0 && result.data.categoryNotBook==1) {
                                    _this.brandType = ["2"];
                                    _this.initBook = true;
                                    _this.initNotBook = false;
                                    _this.getCategory(2);
                                }
                                _this.categoryDeptId = result.data.deptId;
                            } else {
                                _this.$message.error(result.msg)
                            }
                        }
                    })
                }
            })
        },

        methods: {
            fetch (brandApplyId) {
                if (brandApplyId) {
                    var _this = this;
                    $.get({
                        url: "/suppliers/agreementApply/brandApply/find",
                        data: {
                            brandApplyId: _this.brandApplyId
                        },
                        success: function (result) {
                            if (!result.code && result.data) {
                                _this.registeredCountry = result.data.registeredCountry;
                                _this.taxpayerType = result.data.taxpayerType;
                                _this.deptId = result.data.deptId;
                                console.log(result.data)
                                _this.brandInfo = result.data;
                                _this.alSelect = true;
                                _this.brandId = result.data.brandId;
                                _this.brandAgreementId = result.data.brandAgreementId;
                                _this.brandApplyId = result.data.brandApplyId;
                                if (result.data.categoryIsBook==1 && result.data.categoryNotBook==1) {
                                    _this.brandType = ["1","2"];
                                    _this.initBook = false;
                                    _this.initNotBook = false;
                                    _this.categoryDeptId = null;
                                    _this.getCategory(3);
                                } else if (result.data.categoryIsBook==1 && result.data.categoryNotBook==0) {
                                    _this.brandType = ["1"];
                                    _this.initBook = false;
                                    _this.initNotBook = true;
                                    _this.getCategory(1);
                                    _this.categoryDeptId = _this.deptId;
                                } else if (result.data.categoryIsBook==0 && result.data.categoryNotBook==1) {
                                    _this.brandType = ["2"];
                                    _this.initBook = true;
                                    _this.initNotBook = false;
                                    _this.getCategory(2);
                                    _this.categoryDeptId = _this.deptId;
                                }
                                _this.brandInfo.categories = result.data.categories;
                                if(_this.brandInfo.categories.length>0){
                                    for (var i=0;i<_this.brandInfo.categories.length;i++) {
                                        // _this.brandInfo.categories[i].deptId = _this.brandInfo.categoryDeptId;
                                        if (_this.brandInfo.categories[i].franchiseQualification){
                                            _this.brandInfo.categories[i].franchiseQualificationFile = _this.fileTrans(_this.brandInfo.categories[i].franchiseQualificationFile)
                                        }else{
                                            _this.brandInfo.categories[i].franchiseQualificationFile = [];
                                        }
                                    }

                                }

                                _this.provideInvoice = result.data.provideInvoice;
                                _this.brandInfo.businessType = result.data.businessType;
                                _this.brandInfo.goodsType = result.data.goodsType;
                                _this.brandInfo.trademarkRegistrationCertificateFiles = _this.fileTransUrlArray(result.data.trademarkRegistrationCertificateFiles);
                                _this.brandInfo.authCertificateFiles = _this.fileTransUrlArray(result.data.authCertificateFiles);
                                _this.brandInfo.purchaseOrderFiles = _this.fileTransUrlArray(result.data.purchaseOrderFiles);
                                _this.brandInfo.customsDeclarationFormFiles = _this.fileTransUrlArray(result.data.customsDeclarationFormFiles);
                                _this.brandInfo.qualityInspectionFiles = _this.fileTransUrlArray(result.data.qualityInspectionFiles);
                                _this.brandInfo.inspectionQuarantineFiles = _this.fileTransUrlArray(result.data.inspectionQuarantineFiles);
                                if (result.data.qualityInspectionTime) {
                                    _this.dateTime = result.data.qualityInspectionTime;
                                }
                            }
                        }
                    })
                }
            },

            // 搜索
            keySearch () {
                var _this = this;
                var brandName = this.brand_key;
                if (brandName) {
                    $.get({
                        url: '/suppliers/supplierSettled/findBrandByKeyword',
                        data: {
                            brandName: brandName
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.list = result.data.list;

                                if(_this.list.length == 0) {
                                    _this.noDialog = true;
                                } else {
                                    _this.search_result = true;
                                    _this.radio = null;
                                    _this.noSelect = true;
                                }
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: '请输入搜索内容',
                        type: 'error'
                    });
                }

            },
            // 必须选中一个 搜索结果
            change_select (val) {
                if (val) {
                    this.noSelect = false;
                }
            },
            // 选中已选品牌
            sure_select () {
                var id = this.radio;
                for (var i=0 ;i <this.list.length;i++) {
                    if (id == this.list[i].brandId) {
                        this.brandId = this.list[i].brandId;
                        this.brandName = this.list[i].brandName;
                        this.brandEnname = this.list[i].brandEnname;
                        this.alSelect = true;
                    }
                }
                this.search_result = false;
            },
            // 请求一级类目
            getCategory (type) {
                var _this = this;
                $.get({
                    url: '/suppliers/agreementApply/categories/find',
                    data: {
                        type: '1',
                        categoryId: '',
                        deptId: _this.deptId,
                        categoryType: type
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.oneList = result.data.list;
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            // 请求二级类目
            getTowList (value) {
                this.cata.second = null;
                var _this = this;
                if (value == null) {
                    this.twoList = [];
                } else {
                    $.get({
                        url: '/suppliers/agreementApply/categories/find',
                        data: {
                            type: '2',
                            categoryId: value,
                            deptId: _this.deptId
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.twoList = result.data.list;
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }

            },
            // 请求三级类目
            getThreeList (value) {
                this.cata.categoryId = null;
                var _this = this;
                if (value == null) {
                    this.threeList = [];
                } else {
                    $.get({
                        url: '/suppliers/agreementApply/categories/find',
                        data: {
                            type: '3',
                            categoryId: value,
                            deptId: _this.deptId
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.threeList = result.data.list;
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }
            },

            // 请求合作品类   数据
            selectInfo() {
                var id = this.cata.categoryId;
                var _this = this;
                if (id != null) {
                    $.get({
                        url: '/suppliers/agreementApply/categoryAttribute/find',
                        data: {
                            categoryId: id
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.tpmList = result.data;
                                _this.tpmList.ratesStr = '';
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }
            },

            // 添加合作类目
            addDomain () {
                var _this = this;
                if ($.isEmptyObject(this.tpmList)) {
                    this.$message.error('请选择主营品类类目');
                    return;
                } else if (this.deptId !=this.tpmList.deptId) {
                    this.$message.error('主营品类所属部门不一致');
                    return;
                } else {
                    var flag = true;
                    var categories = _this.brandInfo.categories;
                    var level = this.tpmList.category;
                    for (var i = 0; i < categories.length; i++) {
                        var categoryTmp = categories[i];
                        var hisLevel = categoryTmp.category;
                        if (flag && hisLevel.childrenId == level.childrenId) {
                            flag = false;
                        }
                    }
                    if (flag) {
                        if (this.registeredCountry != 1) {
                            this.tpmList.invoiceType = 3;
                        };

                        this.tpmList.provideInvoice = _this.provideInvoice;

                        this.tpmList.franchiseQualificationFile = this.fileTrans(this.tpmList.franchiseQualificationFile)
                        _this.brandInfo.categories.push(this.tpmList)
                        // 添加成功之后
                        this.cata.first = null;
                        this.tpmList = {};
                    } else {
                        this.$message({
                            showClose: true,
                            message: '主营品类已经添加',
                            type: 'error'
                        });
                    }
                }
            },

            // 不提供发票
            selProvideInvoice(row,store){
                var store = store.states.data;
                if(row.provideInvoice==0) {
                    row.invoiceType = null;
                    row.ratesStr = '';
                    for (var i = 0; i < store.length; i++) {
                        store[i].provideInvoice = 0;
                    }
                } else {
                    for (var i = 0; i < store.length; i++) {
                        store[i].provideInvoice = 1;
                    }
                    if (this.registeredCountry == 1) {
                        row.invoiceType = 1;
                    } else {
                        row.invoiceType = 3;
                    }
                }
            },
            // 商品是否进口 change事件
            goodsTypeChange () {
                var that = this;
                if (that.registeredCountry == 1 && that.brandInfo.businessType == 3) {
                    that.brandInfo.businessType = '';
                }
            },
            // 改变发票类型 清空 税率复选框 已选
            selInvoiceType(row){
                row.ratesStr = '';
            },
            // 删除 表格列表 当前行
            deleteDomain (index, tableData) {
                tableData.splice(index, 1)
            },
            // 预览 图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 上传前验证
            beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
                    return isJPG;
                }
                if (!isLt1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return isLt1M;
                }

            },
            // 商标注册证电子版 成功上传1
            handleSuccess1(response, file) {
                if (!response.code) {
                    this.brandInfo.trademarkRegistrationCertificateFiles.push({url:response.data});
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 完整授权链证书电子版  成功上传2
            handleSuccess2(response, file) {
                if (!response.code) {
                    this.brandInfo.authCertificateFiles.push({url:response.data});
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 订货单电子版 成功上传3
            handleSuccess3(response, file) {
                if (!response.code) {
                    this.brandInfo.purchaseOrderFiles.push({url:response.data});
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 报关单电子版  成功上传4
            handleSuccess4(response, file) {
                if (!response.code) {
                    this.brandInfo.customsDeclarationFormFiles.push({url:response.data});
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 质检单电子版  成功上传5
            handleSuccess5(response, file) {
                if (!response.code) {
                    this.brandInfo.qualityInspectionFiles.push({url:response.data});
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 入境货物检验检测 成功上传6
            handleSuccess6(response, file) {
                if (!response.code) {
                    this.brandInfo.inspectionQuarantineFiles.push({url:response.data});
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 上传资质图片
            handleUpload(response,file) {
                var index=parseInt(response.otherData);
                if (!response.code) {
                    this.brandInfo.categories.map((item,num) => {
                        if(index == num) {
                            item.franchiseQualificationFile =  this.fileTrans(response.data);
                            item.uid = file.uid;
                        }
                        return item;
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 删除 品类信息 上传图片
            handleRemove(file) {
                this.brandInfo.categories.map((item,num) => {
                    if(item.uid && item.uid == file.uid) {
                        item.franchiseQualificationFile =  [];
                    }
                    return item;
                });
            },
            // 删除 上传图片 商标注册电子版1
            handleRemoveTrademark(file, fileList) {
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                this.brandInfo.trademarkRegistrationCertificateFiles = picFiles;
            },
            // 删除 上传图片 完整授权链证书电子版2
            handleRemoveAuthCert(file, fileList) {
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                this.brandInfo.authCertificateFiles = picFiles;
            },
            // 删除 上传图片 订货单电子版3
            handleRemovePurchaseOrder(file, fileList) {
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                this.brandInfo.purchaseOrderFiles = picFiles;
            },

            // 删除 上传图片 报关单电子版4
            handleRemoveCustomsForm(file, fileList) {
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                this.brandInfo.customsDeclarationFormFiles = picFiles;
            },

            // 删除 上传图片 质检单电子版5
            handleRemoveQualityInspection(file, fileList) {
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                this.brandInfo.qualityInspectionFiles = picFiles;
            },

            // 删除 上传图片 入境货物检验检测6
            handleRemoveInspectionQuarantine(file, fileList) {
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                this.brandInfo.inspectionQuarantineFiles = picFiles;
            },
            // 提交申请品牌
            submit (formName) {
                var _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.brandType.length == 0) {
                            this.$message.error("请选择品牌合作类型");
                            return;
                        } else if (this.brandInfo.categories.length == 0) {
                            this.$message.error("请添加品牌合作品类");
                            return;
                        }
                        if (_this.brandInfo.brandName == '') {
                            this.$message.error("品牌中文名称不能为空");
                            return;
                        } else if (this.brandType.length == 0) {
                            this.$message.error("请选择品牌合作类型");
                            return;
                        } else if (this.brandInfo.categories.length == 0) {
                            this.$message.error("请添加品牌合作品类");
                            return;
                        }
                        if (this.brandInfo.categoryNotBook == 1) {
                            console.log("非图书")

                            var data = {};
                            data = JSON.parse(JSON.stringify(_this.brandInfo));

                            if (this.registeredCountry == 1) {
                                for (var i=0; i< data.categories.length;i++) {
                                    if (data.categories[i].provideInvoice == 1) {
                                        if (data.categories[i].ratesStr == '') {
                                            this.$message.error('请选择税率');
                                            return;
                                        }
                                    }
                                }
                            }



                            for (var i=0; i< data.categories.length;i++) {
                                data.categories[i].franchiseQualificationFile = this.fileTransToString(data.categories[i].franchiseQualificationFile)
                                if (data.categories[i].franchiseQualification) {
                                    if (data.categories[i].franchiseQualificationFile == '') {
                                        this.$message.error('请上传品类经营特许资质电子版');
                                        return;
                                    }
                                }
                            }

                            data.registeredCountry = _this.registeredCountry;
                            data.trademarkRegistrationCertificateFiles = this.fileTransToArray(_this.brandInfo.trademarkRegistrationCertificateFiles);
                            data.authCertificateFiles = this.fileTransToArray(_this.brandInfo.authCertificateFiles);
                            data.purchaseOrderFiles = this.fileTransToArray(_this.brandInfo.purchaseOrderFiles);
                            data.customsDeclarationFormFiles = this.fileTransToArray(_this.brandInfo.customsDeclarationFormFiles);
                            data.qualityInspectionFiles = this.fileTransToArray(_this.brandInfo.qualityInspectionFiles);
                            data.inspectionQuarantineFiles = this.fileTransToArray(_this.brandInfo.inspectionQuarantineFiles);

                            data.brandId = _this.brandId;
                            data.brandName = _this.brandInfo.brandName;
                            data.brandEnname = _this.brandInfo.brandEnname;
                            data.brandDesc = _this.brandInfo.brandDesc;
                            data.brandGoodsDesc = _this.brandInfo.brandGoodsDesc;
                            data.brandAgreementId = _this.brandAgreementId;
                            data.brandApplyId = _this.brandApplyId;

                            data.brandType = _this.brandInfo.brandType;

                            var categories = [];
                            var categoriesTmp = _this.brandInfo.categories;
                            for (var i = 0; i < categoriesTmp.length; i++) {
                                var categoryTmp = categoriesTmp[i];
                                var category = {};
                                category.ratesStr = categoryTmp.ratesStr;
                                if (!category.ratesStr) { // 加判断后去除
                                    category.rates = [];
                                }else{
                                    category.rates = [category.ratesStr];
                                }
                                category.provideInvoice = categoryTmp.provideInvoice;
                                category.invoiceType = categoryTmp.invoiceType;
                                category.franchiseQualification = categoryTmp.franchiseQualification;
                                category.franchiseQualificationFile = _this.fileTransToString(categoryTmp.franchiseQualificationFile);
                                category.categoryId = categoryTmp.category.childrenId;
                                category.categoryDeposit = categoryTmp.categoryDeposit;
                                categories.push(category);
                            }
                            data.categories = categories;

                            $.ajax({
                                url: '/suppliers/agreementApply/brandApply/save',
                                data: JSON.stringify(data),
                                dataType: "json",
                                contentType: 'application/json;charset=utf-8',
                                type: 'POST',
                                success: function (result) {
                                    if (!result.code) {
                                        _this.$message({
                                            message: '保存成功',
                                            type: 'success'
                                        });
                                        setTimeout(function () {
                                            _this.$router.push({
                                                path:'/category_brand?id=' + _this.brandAgreementId
                                            })
                                        },500)
                                    } else {
                                        _this.$message({
                                            message: result.msg,
                                            type: 'error'
                                        });
                                    }
                                }
                            })
                        } else {
                            console.log("图书类");
                            var data = {};
                            data = JSON.parse(JSON.stringify(_this.brandInfo));

                            for (var i=0; i< data.categories.length;i++) {
                                if (data.categories[i].provideInvoice == 1) {
                                    if (data.categories[i].ratesStr == '') {
                                        this.$message.error('请选择税率');
                                        return;
                                    }
                                }
                            }

                            for (var i=0; i< data.categories.length;i++) {
                                data.categories[i].franchiseQualificationFile = this.fileTransToString(data.categories[i].franchiseQualificationFile)
                                if (data.categories[i].franchiseQualification) {
                                    if (data.categories[i].franchiseQualificationFile == '') {
                                        this.$message.error('请上传品类经营特许资质电子版');
                                        return;
                                    }
                                }
                            }

                            data.registeredCountry = _this.registeredCountry;
                            data.trademarkRegistrationCertificateFiles = this.fileTransToArray(_this.brandInfo.trademarkRegistrationCertificateFiles);
                            data.authCertificateFiles = this.fileTransToArray(_this.brandInfo.authCertificateFiles);
                            data.purchaseOrderFiles = this.fileTransToArray(_this.brandInfo.purchaseOrderFiles);
                            data.customsDeclarationFormFiles = this.fileTransToArray(_this.brandInfo.customsDeclarationFormFiles);
                            data.qualityInspectionFiles = this.fileTransToArray(_this.brandInfo.qualityInspectionFiles);
                            data.inspectionQuarantineFiles = this.fileTransToArray(_this.brandInfo.inspectionQuarantineFiles);

                            // data.brandId = _this.brandId;
                            data.brandName = _this.brandInfo.brandName;
                            data.brandEnname = _this.brandInfo.brandEnname;
                            data.brandDesc = _this.brandInfo.brandDesc;
                            data.brandGoodsDesc = _this.brandInfo.brandGoodsDesc;
                            data.brandAgreementId = _this.brandAgreementId;
                            //data.brandApplyId = _this.brandApplyId;

                            data.brandType = _this.brandInfo.brandType;
                            if (data.brandType) {
                                data.categoryIsBook = 1;
                            } else {
                                data.categoryIsBook = 1;
                                data.categoryNotBook = 0;
                            }

                            var categories = [];
                            var categoriesTmp = _this.brandInfo.categories;
                            for (var i = 0; i < categoriesTmp.length; i++) {
                                var categoryTmp = categoriesTmp[i];
                                var category = {};

                                category.ratesStr = categoryTmp.ratesStr;
                                if (!category.ratesStr) { // 加判断后去除
                                    category.rates = [];
                                }else{
                                    category.rates = [category.ratesStr];
                                }
                                category.provideInvoice = categoryTmp.provideInvoice;
                                category.invoiceType = categoryTmp.invoiceType;
                                category.franchiseQualification = categoryTmp.franchiseQualification;
                                category.franchiseQualificationFile = _this.fileTransToString(categoryTmp.franchiseQualificationFile);
                                category.categoryId = categoryTmp.category.childrenId;
                                category.categoryDeposit = categoryTmp.categoryDeposit;
                                categories.push(category);
                            }
                            data.categories = categories;

                            $.ajax({
                                url: '/suppliers/agreementApply/brandApply/save',
                                data: JSON.stringify(data),
                                dataType: "json",
                                contentType: 'application/json;charset=utf-8',
                                type: 'POST',
                                success: function (result) {
                                    if (!result.code) {
                                        _this.$message({
                                            message: '保存成功',
                                            type: 'success'
                                        });
                                        setTimeout(function () {
                                            _this.$router.push({
                                                path:'/category_brand?id=' + _this.brandAgreementId
                                            })
                                        },500)
                                    } else {
                                        _this.$message({
                                            message: result.msg,
                                            type: 'error'
                                        });
                                    }
                                }
                            })
                        }
                    }

                })
            },

            fileTransToArray(files){
                var fileArray = [];
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            fileArray.push(files[i].url);
                        }
                    }
                }
                return fileArray;
            },

            // [] 图片转化成字符串
            fileTransToString(files){
                var fileStr = "";
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            if(i!=0) {
                                fileStr += ",";
                            }
                            fileStr += files[i].url;
                        }
                    }
                }
                return fileStr;
            },
            // 转化图片 格式[{url}]
            fileTrans(fileUrl){
                var array = [];
                if(fileUrl) {
                    var files = fileUrl.split(',');
                    for(var i=0;i<files.length;i++) {
                        var file = {};
                        file.url = files[i];
                        console.log(file);
                        array.push(file);
                    }
                }
                return array;
            },
            // fetch 图片转化
            fileTransUrlArray(files){
                var urlArray = [];
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        urlArray.push({url:files[i]});
                    }
                }
                return urlArray;
            },

            // 取消申请品牌
            cancel () {
                this.$confirm('取消后系统将不保存您输入的信息。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        path:'/category_brand?id=' + this.brandAgreementId
                    })
                }).catch(() => {
                    console.log("取消")
                });
            },
            getseconds (time) {
                this.brandInfo.qualityInspectionTime = new Date(time).getTime();
            }
        },
        watch: {
            'brandType': function (arr) {
                this.cata.first = null;
                if (arr.indexOf("2") == -1) {
                    this.isBook = true;
                    this.brandInfo.categoryIsBook = 1;
                    this.brandInfo.categoryNotBook = 0;
                    this.getCategory(1);
                } else if (arr.indexOf("1") == -1) {
                    this.isBook = false;
                    this.brandInfo.categoryIsBook = 0;
                    this.brandInfo.categoryNotBook = 1;
                    this.getCategory(2);
                } else {
                    this.brandInfo.categoryIsBook = 1;
                    this.brandInfo.categoryNotBook = 1;
                    this.isBook = false;
                    this.getCategory(3);
                }
            }
        },
        computed: {
            amount: function () {
                return 200 - this.brandInfo.brandDesc.length;
            }
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .add_name {
        padding-left: 70px;
    }
    .w325 {
        width: 325px;
    }
    .result_radio .el-radio + .el-radio {
        margin-left: 10%;
    }
    .dialog-footer {
        text-align: center;
    }
    .radio_group {
        width: 90%;
        padding-left: 15%;
        max-height: 150px;
        overflow-y: scroll;
    }
    .list_radio {
        margin-top: 10px;
        margin-left: 10%;
        width: 40%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .form_color {
        color: rgb(106, 72, 77);
    }
    .rule_star92 {
        position: relative;
        left:-92px;
    }
    .rule_star123 {
        position: relative;
        left:-123px;
    }
    .rule_star148 {
        position: relative;
        left:-148px;
    }
    .rule_star176 {
        position: relative;
        left:-176px;
    }
    .rule_star204 {
        position: relative;
        left:-204px;
    }
    .ml_10 {
        margin-left: -10px;
    }
    .ml200 {
        margin-left: 200px;
    }
    .w500 {
        width:500px;
    }
</style>



// WEBPACK FOOTER //
// new_brand.vue?b29ef75c